import { useState, useEffect } from 'react';

export interface GKToggleableTextAreaProps {
  value: string;
  onChange: (value: string) => void;
  className: string;
}

export const GKToggleableTextArea = (props: GKToggleableTextAreaProps) => {
  const { value, onChange, className } = props;

  const [isEditing, setIsEditing] = useState(false);

  const onBlur = (event) => {
    onChange(event.target.value ? event.target.value : 0);
    setIsEditing(false);
  };

  useEffect(() => {
    const listener = (event) => {
      // faire marcher le process avec la touche entrée
      if (
        (event.code === 'Enter' || event.code === 'NumpadEnter') &&
        isEditing
      ) {
        onChange(event.target.value ? event.target.value : 0);
        setIsEditing(false);
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [isEditing]);

  return (
    <div style={{ width: '100%' }} className={className}>
      {isEditing ? (
        <textarea
          defaultValue={value}
          onChange={(e) => onChange(e.currentTarget.value)}
          onBlur={onBlur}
          autoFocus
          style={{ boxSizing: 'border-box' }}
        />
      ) : (
        <p onClick={() => setIsEditing(true)}>{value}</p>
      )}
    </div>
  );
};

export default GKToggleableTextArea;
